import React from 'react'

const TeamsIcon = () => {
    return (
        <div><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 18.3332C10 18.3332 16.6667 14.9998 16.6667 9.99984V4.1665L10 1.6665L3.33337 4.1665V9.99984C3.33337 14.9998 10 18.3332 10 18.3332Z" stroke="#DCC5A0" stroke-width="1.45833" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        </div>
    )
}

export default TeamsIcon